import { Card, Button } from "antd";
import { ArticleCategories } from "@modules";
import { Breadcrumb } from "@components";
import { Link } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";

export default function ListPage() {
  return (
    <div className="container max-content">
      <Breadcrumb
        data={[{ title: "Article Categories", href: "/article_categories" }]}
      />
      <div className="flex justify-between items-center flex-wrap mb-5">
        <h1 className="text-3xl">Article Categories</h1>
        <Link to="/article_categories/new">
          <Button className="m-0" icon={<PlusOutlined />} type="primary">
            Add New
          </Button>
        </Link>
      </div>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <ArticleCategories.List />
          </Card>
        </div>
      </div>
    </div>
  );
}
